<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="back()"><ion-icon name="arrow-back-outline"></ion-icon></ion-button>
    </ion-buttons>
    <ion-title>Settings</ion-title>
    <ion-buttons slot="end">
      <ion-button color="danger" fill="clear" (click)="confirmSignOut()">Sign Out</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item>
      <ion-icon name="map-outline" slot="start"></ion-icon>
      <ion-select
        placeholder="Select map type"
        (ionChange)="selectMapType()"
        label="Map type"
        [(ngModel)]="selectedMapType"
      >
        <ion-select-option *ngFor="let mapType of mapTypes" value="{{mapType.value}}">
          {{mapType.name}}
        </ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item>
      <ion-icon name="analytics-outline" slot="start"></ion-icon>
      <ion-toggle [(ngModel)]="selectedSnapToRoad" (ionChange)="selectSnapToRoad()">
        Snap to road
      </ion-toggle>
    </ion-item>
    <ion-item>
      <ion-icon name="git-commit-outline" slot="start"></ion-icon>
      <ion-toggle [(ngModel)]="selectedInterval" (ionChange)="selectInterval()">
        Interval placing
      </ion-toggle>
    </ion-item>
    <ion-item [formGroup]="settingsControls">
      <ion-icon name="git-commit-outline" slot="start"></ion-icon>
      <ion-input
        type="number"
        formControlName="selectedIntervalMControl"
        class="ion-text-right"
        (ionInput)="selectIntervalM()"
        label="Interval (m)"
        value=""
      ></ion-input>
    </ion-item>
    <ion-item *ngIf="native">
      <ion-icon name="flashlight-outline" slot="start"></ion-icon>
      <ion-toggle [(ngModel)]="selectedLightUpQR" (ionChange)="selectLightUpQR()">
        Light up QR
      </ion-toggle>
    </ion-item>
    <ion-item *ngIf="native">
      <ion-icon name="cloud-done-outline" slot="start"></ion-icon>
      <ion-toggle [(ngModel)]="selectedAutocalibration" (ionChange)="selectAutocalibration()">
        Auto calibration
      </ion-toggle>
    </ion-item>
    <ion-item>
      <ion-icon name="contrast-outline" slot="start"></ion-icon>
      <ion-toggle [(ngModel)]="selectedDarkMode" (ionChange)="changeTheme()">
        Dark mode
      </ion-toggle>
    </ion-item>
  </ion-list>
</ion-content>

<ion-footer class="main-footer ion-padding">
  <div class="delete-account">
    <ion-button
      expand="block"
      fill="outline"
      color="danger"
      (click)="confirmDeleteAccount()"
      size="small"
      style="text-transform:none"
    >
      Delete account
    </ion-button>
  </div>
  <div class="version-container">
    <ion-text color="dark">Nwave <ion-img [src]="logoSrc" class="logo"></ion-img> SPlace {{appVersion}}</ion-text>
  </div>
</ion-footer>
